import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper";

const LandingButton = ({ blok }) => {
  // console.log(blok)
  return (
    <div id={blok?.id} {...storyblokEditable(blok)} className={`container mx-auto px-5 flex justify-center`} 
      style={{}}>
      <a href={Href(blok.ctaUrl)} 
        className={`${blok.style === 'outline' ? 
          'border-blue-700 text-blue-700 hover:border-blue-600 hover:text-blue-600' : 
          'bg-blue-700 text-white hover:bg-blue-600'} 
          border-2 rounded-lg py-2 px-8 flex items-center justify-center transition`}
        style={{
          width: `${blok.buttonWidth}px`,
          fontSize: `${blok.fontSize}px`,
          paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`,
          marginTop: `${blok.marginTop}px`, marginBottom: `${blok.marginBottom}px`,
        }}>
        <span>{blok.ctaText}</span>
        <img className="w-8 h-3 align-middle ml-4" loading="lazy" src={ `${blok.style === 'outline' ? 
          '/icons/arrow-right-blue.svg': '/icons/arrow-right-white.svg'}`} alt="Arrow right"/>
      </a>
    </div>)
}

export default LandingButton
